import fhirpath from 'fhirpath';

const CODEABLE_CONCEPT_DISPLAY_PATH = `select((text | coding.display).first())`;
const FHIR_RESOURCE_TITLE_PATH: Partial<
  Record<fhir4.FhirResource['resourceType'], string>
> = {
  MedicationRequest: `((
            medicationCodeableConcept
            | contained.where(resourceType = 'Medication').code
        ).first()).${CODEABLE_CONCEPT_DISPLAY_PATH}`,
  ServiceRequest: `code.${CODEABLE_CONCEPT_DISPLAY_PATH}`,
  CarePlan: `title`,
  Appointment: `serviceType.${CODEABLE_CONCEPT_DISPLAY_PATH}`,
};

export function getFHIRResourceTitle(resource: fhir4.FhirResource): string {
  const path = FHIR_RESOURCE_TITLE_PATH[resource.resourceType];
  if (path) {
    return fhirpath.evaluate(resource, path)?.[0] ?? '';
  }

  return '';
}
